import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Typography from '@material-ui/core/Typography'
import RestoreIcon from '@material-ui/icons/Restore'
import PlaceIcon from '@material-ui/icons/Place'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PersonIcon from '@material-ui/icons/Person'
import InfoIcon from '@material-ui/icons/Info'

import dateformat from 'dateformat'
import { deepCopy } from '../../../lib'
import { authorTypeItems, authorType } from '../../../constants';
import { WID } from '../../../constants/Language';
import { Word } from '../../../containers';


dateformat.i18n = {
  dayNames: [
      '日', '月', '火', '水', '木', '金', '土',
      '日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'
  ],
  monthNames: [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ],
  timeNames: [
    'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
  ]
}

const styles = theme => ({
  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  thumbnailBox: {
    width: '100%',
  },
  overview: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  datetimeBox: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
    textAlign: 'center',
    width: 50,
  },
  month: {
    color: theme.palette.grey[700],
    fontSize: '0.825rem',
  },
  day: {
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
    width: 50,
  },
  typography: {
    color: theme.palette.grey[700],
    display: 'flex',
    alignItems: 'center',
  },
  contentBox: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    width: '100%',
  },
  icon: {
    fontSize: '0.825rem',
    marginRight: theme.spacing.unit / 2,
  },
  eventName: {
    fontWeight: 700,
    color: theme.palette.grey[900],
    verticalAlign: 'center',
    marginBottom: theme.spacing.unit / 2,
  },
})

class EventOverview extends React.Component {
  render() {
    const { classes, theme, record, type, fullAddress, noWrap, action } = this.props
    var startDateTime, endDateTime, startMonth, startDay, address, addressComponents, strStartDt, strEndDt, styles, authorTypeItem
    if ('startDate' in record && 'startTime' in record) {
      startDateTime = new Date(record.startDate + record.startTime)
      strStartDt = dateformat(record.startDate + record.startTime, 'ddd HH:MM')
    }
    else if ('startDate' in record) {
      startDateTime = new Date(record.startDate)
      strStartDt = dateformat(record.startDate, 'ddd')
    }
    if ('endDate' in record && 'endTime' in record) {
      endDateTime = new Date(record.endDate + record.endTime)
      if (startDateTime.getDate() === endDateTime.getDate()) {
        strEndDt = dateformat(record.endDate + record.endTime, 'HH:MM')
      }
      else {
        strEndDt = dateformat(record.endDate + record.endTime, 'm月d日(ddd) HH:MM')
      }
    }
    else if ('endDate' in record) {
      endDateTime = new Date(record.endDate)
      if (startDateTime.getDate() !== endDateTime.getDate()) {
        strEndDt = dateformat(record.endDate, 'm月d日(ddd)')
      }
    }
    startMonth = startDateTime.getMonth() + 1
    startDay = startDateTime.getDate()
    address = ''
    if (fullAddress) {
      address = record.address
    }
    else if (record.addressComponents) {
      addressComponents = deepCopy(record.addressComponents)
      addressComponents.reverse()
      addressComponents = addressComponents.filter((comp) => comp.types.some((type) => type !== 'postal_code'))
      addressComponents.slice(0,3).forEach((comp) => {
        if (comp.types.some((type) => type === 'country')) {
          return
        }
        address += comp.long_name
      })
    }
    if (type === 'cardTitle') {
      styles = {
        datetimeBox: {
        },
        contentBox: {
          paddingLeft: theme.spacing.unit * 2,
          borderLeft: `${theme.spacing.unit}px solid ${theme.palette.grey[200]}`
        },
        name: {
          fontSize: '1.25rem',
          fontWeight: 100,
        },
        typography: {
          fontSize: '1rem'
        }
      }
    }
    else {
      styles = {}
    }
    authorTypeItem = record.authorType === parseInt(authorType.CONTRIBUTOR, 10) ?
      authorTypeItems.find(item => parseInt(item.value, 10) === record.authorType) : undefined
    return (
      <div className={classes.overview}>
        <div className={classes.datetimeBox} style={styles.datetimeBox}>
          <Typography className={classes.month}>{startMonth}<Word wid={WID.EVENT_OVERVIEW.MONTH}/></Typography>
          <Typography className={classes.day}>
            {startDay}
            <span style={{fontSize: '1rem', marginLeft: theme.spacing.unit / 2}}><Word wid={WID.EVENT_OVERVIEW.DAY}/></span>
          </Typography>
        </div>
        <div className={classes.contentBox} style={styles.contentBox}>
          <div className={classes.flexBetween}>
            <Typography className={classes.eventName} style={styles.name} noWrap={noWrap}>
              {record.name}
            </Typography>
            {action}
          </div>
          {address && (
            <Typography className={classes.typography} style={styles.typography} noWrap={noWrap}>
              <PlaceIcon color='inherit' className={classes.icon}/>
              {address}
            </Typography>
          )}
          {strStartDt && (
            <Typography className={classes.typography} style={styles.typography} noWrap={noWrap}>
              <AccessTimeIcon color='inherit' className={classes.icon}/>
              {`${strStartDt}${strEndDt ? ' - ' + strEndDt : ''}`}
            </Typography>
          )}
          {authorTypeItem && (
            <Typography className={classes.typography} style={styles.typography} noWrap={noWrap}>
              <PersonIcon color='inherit' className={classes.icon}/>
              <Word wid={authorTypeItem.wid}/>{` : ${record.author.displayName}`}
            </Typography>
          )}
          {parseInt(authorType.PROVIDER, 10) === record.authorType && (
            <Typography className={classes.typography} style={styles.typography} noWrap={noWrap}>
              <InfoIcon color='inherit' className={classes.icon}/>
              <Word wid={WID.EVENT_OVERVIEW.PROVIDER}/>
            </Typography>
          )}
          {record.rev !== undefined && (
            <Typography className={classes.typography} style={styles.typography} noWrap={noWrap}>
              <RestoreIcon color='inherit' className={classes.icon}/>
              <Word wid={WID.EVENT_OVERVIEW.REVISION}/> {record.rev}
            </Typography>
          )}
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(EventOverview)


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventOverview.js